import script from "./MediaflowSceneCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowSceneCanvas.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowSceneCanvas.vue?vue&type=style&index=0&id=63a32c12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a32c12"]])

export default __exports__